import supportedTypes from './supported-file-types.json';
import { getExtFromFileName } from './UtilFunctions';

interface SupportedFileType {
  extension: string;
  supported: { chrome: number };
}

interface SupportedTypesData {
  images: SupportedFileType[];
  videos: SupportedFileType[];
  audios: SupportedFileType[];
  documents: SupportedFileType[];
}

const data = supportedTypes as SupportedTypesData;

function getSupportedFilesList(genre: string): SupportedFileType[] {
  switch (genre) {
    case 'image': return data.images;
    case 'video': return data.videos;
    case 'audio': return data.audios;
    case 'doc': return data.documents;
    default: return [];
  }
}

function isExtensionSupported(genre: string, ext: string): boolean {
  const supportedList = getSupportedFilesList(genre);
  const supportedExtensions = supportedList
    .filter((item) => item.supported.chrome === 1)
    .map((item) => item.extension);
  return supportedExtensions.some((supportedExt) => supportedExt === ext);
}

export function validateFileTypeRendability(fileGenre: string | undefined, fileExt: string): boolean {
  if (!fileGenre) return false;
  return isExtensionSupported(fileGenre, fileExt);
}

export function validateLocalVideoFileRendability(file: File): boolean {
  const genre = file.type.split('/')[0];
  const ext = getExtFromFileName(file.name) as string;
  return validateFileTypeRendability(genre, ext);
}
